import { Pipe, PipeTransform, inject } from '@angular/core';

import { AuthService } from 'src/app/_core/authorization/auth.service';

@Pipe({
  name: 'agrFeature',
  standalone: false
})
export class FeaturePipe implements PipeTransform {
  private authService = inject(AuthService);

  transform(featureRef: string): any {
    return this.authService.hasFeature(featureRef);
  }
}
